import * as React from "react";
import { Route, Switch } from "react-router";
import { useSelector } from "react-redux";
import { routes } from "../constants";
import Dashboard from "./components/body/dashboard/dashboard";
import Appointments from "./components/body/appointment/appointments";
import Branches from "./components/body/branches/branches";
import MedicalRecords from "./components/body/medical-records/medical-records";
import Billing from "./components/body/billings/billing";
import ClientPortalSettings from "./components/body/settings/setting";
import Sidebar from "./components/sidebar/sidebar";
import TopBar from "./components/topbar/topbar";
import styles from "./client-portal-routes.module.scss";
import ClientPortalLogin from "./components/body/login/login";
import { RootState } from "../store";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "./components/body/page-not-found/page-not-found";
import Notifications from "../containers/FlashMessage/Notification";
import Lab from "./components/body/lab/lab";

const ClientPortalRoutes = (): React.JSX.Element => {
  const { clientPortal } = routes;
  const { dashBoard, appointments, branches, medicalReports, billing, settings, login, lab } =
    routes.clientPortal.subRoutes;
  const isClientPortalUserAuthenticated = useSelector(
    (state: RootState) => state.isClientPortalUserAuthenticated
  );

  return (
    <Switch>
      <Route exact path={`${clientPortal.name}/${login.name}`} component={ClientPortalLogin} />
      <Route
        path={clientPortal.name}
        render={() => (
          <div className={styles.mainContainer}>
            <Notifications />
            {isClientPortalUserAuthenticated && <Sidebar />}
            <div className={styles.contentContainer}>
              {isClientPortalUserAuthenticated && <TopBar />}
              <Switch>
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${dashBoard.name}`}
                  component={Dashboard}
                />
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${appointments.name}`}
                  component={Appointments}
                />
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${branches.name}`}
                  component={Branches}
                />
                <PrivateRoute exact path={`${clientPortal.name}/${lab.name}`} component={Lab} />
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${medicalReports.name}`}
                  component={MedicalRecords}
                />
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${billing.name}`}
                  component={Billing}
                />
                <PrivateRoute
                  exact
                  path={`${clientPortal.name}/${settings.name}`}
                  component={ClientPortalSettings}
                />
                <Route component={PageNotFound} />
              </Switch>
            </div>
          </div>
        )}
      />
    </Switch>
  );
};

export default ClientPortalRoutes;
